import React from "react"
import { COLORS } from "../../utilities/Constants"

// Self-contained: the component injects its own keyframes so it can be dropped
// anywhere with no SCSS / gulp build step. Named uniquely to avoid clashes.
const KEYFRAMES = `
@keyframes svp-loader-spin { to { transform: rotate(360deg); } }
@keyframes svp-loader-bounce {
	0%, 80%, 100% { transform: scale(0.5); opacity: 0.35; }
	40% { transform: scale(1); opacity: 1; }
}
@keyframes svp-loader-pulse {
	0%, 100% { transform: scale(0.9); opacity: 0.55; }
	50% { transform: scale(1); opacity: 1; }
}
`

const Ring = ({ size, color }) => (
	<div
		style={{
			width: size,
			height: size,
			borderRadius: "50%",
			border: `${Math.max(2, Math.round(size / 12))}px solid ${COLORS.border}`,
			borderTopColor: color,
			animation: "svp-loader-spin 0.7s linear infinite",
			boxSizing: "border-box",
		}}
	/>
)

const Dots = ({ size, color }) => {
	const d = Math.max(6, Math.round(size / 3.4))
	return (
		<div style={{ display: "flex", gap: Math.round(d * 0.6) }}>
			{[0, 1, 2].map((i) => (
				<span
					key={i}
					style={{
						width: d,
						height: d,
						borderRadius: "50%",
						backgroundColor: color,
						animation: `svp-loader-bounce 1.1s ease-in-out ${i * 0.15}s infinite both`,
					}}
				/>
			))}
		</div>
	)
}

const Brand = ({ size }) => (
	<div
		style={{
			width: size,
			height: size,
			borderRadius: Math.round(size * 0.28),
			backgroundColor: COLORS.text,
			color: "#fff",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontWeight: 700,
			fontSize: Math.round(size * 0.5),
			fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
			animation: "svp-loader-pulse 1.1s ease-in-out infinite",
		}}
	>
		S
	</div>
)

const VARIANTS = { ring: Ring, dots: Dots, brand: Brand }

const Loader = ({
	variant = "ring",
	size = 40,
	message = null,
	color = COLORS.text,
	fullPage = false,
	padding = 60,
}) => {
	const Visual = VARIANTS[variant] || Ring
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 14,
				fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
				...(fullPage ? { minHeight: "60vh" } : { padding }),
			}}
		>
			<style>{KEYFRAMES}</style>
			<Visual size={size} color={color} />
			{message && (
				<div
					style={{
						fontSize: 13,
						fontWeight: 500,
						color: COLORS.textMuted,
					}}
				>
					{message}
				</div>
			)}
		</div>
	)
}

export default Loader
